import { observer } from 'mobx-react-lite'
import { FinalReturnAmountsCard } from '@/features/jobs/details/components/FinalReturnAmountsCard'
import { FinalReturnAmountsDialogContainer } from '@/features/jobs/details/components/FinalReturnAmountsDialog/FinalReturnAmountsDialogContainer'
import { type FinalReturnAmountsCardViewModel } from './FinalReturnAmountsCardViewModel'
import { formatReturnAmountsSource } from './return-amounts'

export interface FinalReturnAmountsCardContainerProps {
  vm: FinalReturnAmountsCardViewModel
}

export const FinalReturnAmountsCardContainer = observer(
  function FinalReturnAmountsCardContainer({
    vm,
  }: FinalReturnAmountsCardContainerProps) {
    return (
      <FinalReturnAmountsCard
        canEdit={vm.canEdit}
        onEdit={vm.edit}
        years={vm.years.map((year) => ({
          taxYear: year.taxYear,
          federalAmount: year.federalAmount,
          federalSourceLabel: formatReturnAmountsSource(year.federalSource),
          stateAmounts: year.stateAmounts.map((state) => ({
            state: state.state,
            amount: state.amount,
            sourceLabel: formatReturnAmountsSource(state.source),
          })),
        }))}
      >
        <FinalReturnAmountsDialogContainer
          vm={vm.dialogVm}
          submitLabel="Save"
        />
      </FinalReturnAmountsCard>
    )
  },
)
